import * as ambassadorWixLoyaltyV1LoyaltyEarningRule from './loyalty-v1-loyalty-earning-rule-earning-rules.http.js';
import * as ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes from './loyalty-v1-loyalty-earning-rule-earning-rules.types.js';
import * as ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes from './loyalty-v1-loyalty-earning-rule-earning-rules.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createLoyaltyEarningRule(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.CreateLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.CreateLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.CreateLoyaltyEarningRuleResponse,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.CreateLoyaltyEarningRuleResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1LoyaltyEarningRule.createLoyaltyEarningRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/earning-rules',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateLoyaltyEarningRules(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.BulkCreateLoyaltyEarningRulesRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.BulkCreateLoyaltyEarningRulesRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.BulkCreateLoyaltyEarningRulesResponse,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.BulkCreateLoyaltyEarningRulesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1LoyaltyEarningRule.bulkCreateLoyaltyEarningRules(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/earning-rules/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCustomLoyaltyEarningRule(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.CreateCustomLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.CreateCustomLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.CreateCustomLoyaltyEarningRuleResponse,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.CreateCustomLoyaltyEarningRuleResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1LoyaltyEarningRule.createCustomLoyaltyEarningRule(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/earning-rules/custom',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLoyaltyEarningRule(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.GetLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.GetLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.GetLoyaltyEarningRuleResponse,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.GetLoyaltyEarningRuleResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1LoyaltyEarningRule.getLoyaltyEarningRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/earning-rules/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLoyaltyEarningRule(): __PublicMethodMetaInfo<
  'PUT',
  { earningRuleId: string },
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.UpdateLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.UpdateLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.UpdateLoyaltyEarningRuleResponse,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.UpdateLoyaltyEarningRuleResponse
> {
  const payload = { earningRule: { id: ':earningRuleId' } } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1LoyaltyEarningRule.updateLoyaltyEarningRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/earning-rules/{earningRule.id}',
    pathParams: { earningRuleId: 'earningRuleId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteLoyaltyEarningRule(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.DeleteLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.DeleteLoyaltyEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.DeleteLoyaltyEarningRuleResponse,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.DeleteLoyaltyEarningRuleResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1LoyaltyEarningRule.deleteLoyaltyEarningRule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/earning-rules/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAutomationEarningRule(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.DeleteAutomationEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.DeleteAutomationEarningRuleRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.DeleteAutomationEarningRuleResponse,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.DeleteAutomationEarningRuleResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1LoyaltyEarningRule.deleteAutomationEarningRule(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/automation-earning-rules/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listEarningRules(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.ListEarningRulesRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.ListEarningRulesRequest,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleUniversalTypes.ListEarningRulesResponse,
  ambassadorWixLoyaltyV1LoyaltyEarningRuleTypes.ListEarningRulesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1LoyaltyEarningRule.listEarningRules(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/earning-rules/rules',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LoyaltyEarningRule as LoyaltyEarningRuleOriginal,
  LoyaltyEarningRuleTypeOneOf as LoyaltyEarningRuleTypeOneOfOriginal,
  FixedAmount as FixedAmountOriginal,
  FixedAmountConfig as FixedAmountConfigOriginal,
  ConversionRate as ConversionRateOriginal,
  ConversionRateConfig as ConversionRateConfigOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Metadata as MetadataOriginal,
  LoyaltyEarningRuleTypeTag as LoyaltyEarningRuleTypeTagOriginal,
  LoyaltyEarningRuleTypeTagType as LoyaltyEarningRuleTypeTagTypeOriginal,
  LoyaltyEarningRuleTypeTagTypeWithLiterals as LoyaltyEarningRuleTypeTagTypeWithLiteralsOriginal,
  AutomationTriggerFilter as AutomationTriggerFilterOriginal,
  CacheInvalidated as CacheInvalidatedOriginal,
  EarningRuleDisabled as EarningRuleDisabledOriginal,
  CreateLoyaltyEarningRuleRequest as CreateLoyaltyEarningRuleRequestOriginal,
  CreateLoyaltyEarningRuleResponse as CreateLoyaltyEarningRuleResponseOriginal,
  BulkCreateLoyaltyEarningRulesRequest as BulkCreateLoyaltyEarningRulesRequestOriginal,
  BulkCreateLoyaltyEarningRulesResponse as BulkCreateLoyaltyEarningRulesResponseOriginal,
  BulkLoyaltyEarningRuleResult as BulkLoyaltyEarningRuleResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  CreateCustomLoyaltyEarningRuleRequest as CreateCustomLoyaltyEarningRuleRequestOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  CustomLoyaltyEarningRule as CustomLoyaltyEarningRuleOriginal,
  CustomLoyaltyEarningRuleTypeOneOf as CustomLoyaltyEarningRuleTypeOneOfOriginal,
  CreateCustomLoyaltyEarningRuleResponse as CreateCustomLoyaltyEarningRuleResponseOriginal,
  GetLoyaltyEarningRuleRequest as GetLoyaltyEarningRuleRequestOriginal,
  GetLoyaltyEarningRuleResponse as GetLoyaltyEarningRuleResponseOriginal,
  UpdateLoyaltyEarningRuleRequest as UpdateLoyaltyEarningRuleRequestOriginal,
  UpdateLoyaltyEarningRuleResponse as UpdateLoyaltyEarningRuleResponseOriginal,
  DeleteLoyaltyEarningRuleRequest as DeleteLoyaltyEarningRuleRequestOriginal,
  DeleteLoyaltyEarningRuleResponse as DeleteLoyaltyEarningRuleResponseOriginal,
  DeleteAutomationEarningRuleRequest as DeleteAutomationEarningRuleRequestOriginal,
  DeleteAutomationEarningRuleResponse as DeleteAutomationEarningRuleResponseOriginal,
  ListEarningRulesRequest as ListEarningRulesRequestOriginal,
  ListEarningRulesResponse as ListEarningRulesResponseOriginal,
  ListEarningRulesInTierRequest as ListEarningRulesInTierRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListEarningRulesInTierResponse as ListEarningRulesInTierResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  InvalidateEarningRuleCacheRequest as InvalidateEarningRuleCacheRequestOriginal,
  InvalidateEarningRuleCacheResponse as InvalidateEarningRuleCacheResponseOriginal,
  AppInstallationInLoyaltySite as AppInstallationInLoyaltySiteOriginal,
  V1Type as V1TypeOriginal,
  V1TypeWithLiterals as V1TypeWithLiteralsOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-v1-loyalty-earning-rule-earning-rules.types.js';
